import React from 'react'
import { variantProvider } from '@/app'
import { LearnGroup } from '@/types'
import { Text, Touchable, View } from '@/components'
import { PersonaBackground } from '../atoms'

type PersonaGroupCardProps = {
  item: LearnGroup
  onPress: (item: LearnGroup) => void
}

export const PersonaCard = ({ onPress }: PersonaGroupCardProps) => {
  return (
    <Touchable
      style={[styles.container, { backgroundColor: 'blue', overflow: 'hidden' }]}
      onPress={onPress}
      debugName="LearnGroups:Touchable"
    >
      <PersonaBackground />
      <View variants={['fullHeight', 'column']} style={{ justifyContent: 'flex-end' }}>
        <Text text="Your learning journey" variants={['h2', 'bold', 'color:neutral1']} style={styles.title} />
      </View>
    </Touchable>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    container: {
      ...theme.presets.fullWidth,
      ...theme.presets.relative,
      height: 125,
      ...theme.presets.row,
      ...theme.spacing.paddingVertical(2.5),
      ...theme.spacing.paddingHorizontal(2),
      borderRadius: theme.borderRadius.small,
      ...theme.presets.justifySpaceBetween,
      boxShadow: '0px 24.05px 24.05px rgba(153, 153, 153, 0.2)',
      [theme.media.down('mid')]: {
        maxWidth: '100%'
      }
    },
    title: {
      zIndex: 1
    },
    image: {
      width: 86,
      height: 85,
      objectFit: 'cover'
    }
  }),
  true
)
